import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../../utils/storeApp";
import { Column } from "primereact/column";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../../ReportsDropdown";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ListUserAccountHistory = () => {
  const navigate = useNavigate();
  const { sharedObject } = useUserStore((state) => ({
    sharedObject: state.sharedObject,
  }));
  const [userObj, setUserObj] = useState([]);
  useEffect(() => {
    let obj = sharedObject.UserActiviyHistory;
    if (obj && Object.keys(obj).length > 0) {
      setUserObj(obj.List);
    }
  }, [sharedObject.UserActiviyHistory]);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setUserObj(sharedObject.UserActiviyHistory.List);
  };

  const TimeStamp = (dt) => {
    return dt.timeStamp
      ? new Date(dt.timeStamp).toLocaleString("en-US", { hour12: false })
      : null;
  };

  const actorBodyTemplate = (dt) => dt?.actor?.split("|")[0];

  return (
    <div className="ListUserAccountHistory">
      <div className="HeaderUserActivityTool">
        <header>
          <div className="btnback-container-1">
            <Link
              aria-label="Go back to User Activity"
              onClick={(e) => {
                navigate("/user-activity");
                e.preventDefault();
              }}
            >
              <i className="bi bi-arrow-left-square-fill spacer-margin5" aria-hidden="true"></i>
            </Link>
          </div>
          <h4 className="title-label4">
            {sharedObject?.UserActiviyHistory?.Name} Activity History
          </h4>
          <aside className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-target="#userActivityHistorySearchModal"
              data-toggle="modal"
              aria-label="Search"
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>
            <span className="SharedTools" role="group" aria-label="Export and print tools">
              <DownloadTableExcel
                filename="UserHistoryReport"
                sheet="Reports"
                currentTableRef={componentRef.current}
              >
                <button
                  className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                  aria-label="Download report"
                >
                  <i className="bi bi-download" aria-hidden="true"></i>
                </button>
              </DownloadTableExcel>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                aria-label="Refresh page"
                onClick={(e) => {
                  if (userObj?.length > 0) refreshPage();
                }}
              >
                <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
              </button>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                aria-label="Print page"
                onClick={(e) => {
                  if (userObj?.length > 0) {
                    handlePrint();
                  }
                }}
              >
                <i className="bi bi-printer" aria-hidden="true"></i>
              </button>
            </span>
          </aside>
        </header>
      </div>
      <section className="grid-layout" ref={componentRef}>
        <div>
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 25, 50]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
              >
                <Column
                  field="eventType"
                  header="Event Type"
                  className="w-md5"
                  sortable
                ></Column>
                <Column
                  field="actor"
                  header="Performed By"
                  className="w-md6"
                  body={actorBodyTemplate}
                  sortable
                ></Column>
                <Column
                  field="timeStamp"
                  header="Event Date"
                  className="w-md8"
                  body={TimeStamp}
                  sortable
                ></Column>
                <Column field="note" header="Note" sortable></Column>
              </DataTable>
              {/* <Paginator
                          first={firstHistory}
                          rows={rowsHistory}
                          totalRecords={historyData?.length}
                          onPageChange={onPageChangeHistory}
                        />
                        <span className="">
                          {firstHistory} - {lastHistory} of{" "}
                          {historyData?.length}
                        </span> */}
            </div>
          ) : (
            <section className="empty-grid" role="status" aria-live="polite" aria-atomic="true">
              There are currently no search results.
            </section>
          )}
        </div>
      </section>
      {/*  ) : null}*/}
    </div>
  );
};

export default ListUserAccountHistory;
